import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../static/icons/chevron.svg'


const _hoisted_1 = { class: "hamburger-menu__child-link-section-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "hamburger-menu__child-link-section-arrow",
  src: _imports_0
}, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "hamburger-menu__child-link-section"
}
const _hoisted_4 = {
  key: 2,
  class: "hamburger-menu__child-links"
}
const _hoisted_5 = {
  key: 0,
  class: "hamburger-menu__child-link-item hamburger-menu__child-link-item--all"
}

import {
  ref, watch, inject, computed,
} from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'HamburgerMenuSection',
  props: {
  menuSection: {
    type: Object,
    required: true,
  },
  featured: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const { websiteText } = useWebsiteTexts();
const isOpen = ref(props.featured);

function toggle() {
  isOpen.value = !isOpen.value;
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.featured)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "hamburger-menu__child-link-section clean-button",
          onClick: toggle
        }, [
          _createTextVNode(_toDisplayString(__props.menuSection.label) + " ", 1),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (__props.featured)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.menuSection.label), 1))
      : _createCommentVNode("", true),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (!__props.featured && __props.menuSection.url)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: __props.menuSection.url,
                  class: "hamburger-menu__child-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(websiteText)("navigation__section_all", {section: __props.menuSection?.label?.toLowerCase()}).value), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuSection.items?.filter((i) => i.type === 'MenuItem'), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "hamburger-menu__child-link-item",
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                to: item.url,
                class: "hamburger-menu__child-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})